import { useState } from 'react';
import { motion } from 'framer-motion';
import { Play, Pause } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function OutputSidebar() {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      className="space-y-6 rounded-lg bg-white p-6 shadow-sm"
    >
      <div className="aspect-video overflow-hidden rounded-lg bg-gray-100">
        <div className="relative h-full">
          <img
            src="https://images.unsplash.com/photo-1593697821028-7cc59cfd7399"
            alt="Video Thumbnail"
            className="h-full w-full object-cover"
          />
          <Button
            onClick={() => setIsPlaying(!isPlaying)}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full p-4"
          >
            {isPlaying ? (
              <Pause className="h-6 w-6" />
            ) : (
              <Play className="h-6 w-6" />
            )}
          </Button>
        </div>
      </div>
    </motion.div>
  );
}